import Bugsnag from '@bugsnag/js';

const createBox = () => {
  // const bundleInstructions = document.querySelector('.bundle-instructions');
  // const header = document.getElementById('header-nav');

  // if (header) {
  //   // const height = bundleInstructions.offsetHeight;
  //   const headerHeight = header.offsetHeight;

  //   let root = document.documentElement;

  //   root.style.setProperty('--box-offset-x', headerHeight + 'px');

  //   // root.style.setProperty('--box-offset-x', headerHeight + 'px');
  // }

  // Check for WooCommerce notice
  const Notice = document.querySelector('.woocommerce-notices-wrapper');

  if (Notice.innerHTML !== '') {
    const pos = Notice.getBoundingClientRect().top + window.pageYOffset - 125;

    // Scroll to notice
    window.scrollTo({ top: pos, behavior: 'smooth' });
  }

  const checkboxes = document.querySelectorAll(
    '.bundled_product_optional_checkbox input'
  );

  const params = new URLSearchParams(window.location.search).toString();

  // No query params, uncheck all checkboxes
  if (!params) {
    // Uncheck all of the checkboxes
    checkboxes.forEach((el) => (el.checked = false));
  }

  // Box Upgrade code
  const packageElm = document.querySelector(
    '.bundled_product:not(.bundled_item_optional) .bundled_item_cart_content'
  );

  if (packageElm) {
    if (!params) {
      let select = packageElm.querySelector('select');

      // Select the last option
      select.selectedIndex = select.options.length - 1;
    }

    let data = packageElm.dataset.product_variations;

    data = eval(data);

    // Create custom event to send data to vuejs
    const event = new CustomEvent('package', {
      detail: { data }
    });

    // Send custom event
    packageElm.dispatchEvent(event);
  }

  // Functon to update the button text
  const buttonText = (checkbox) => {
    if (checkbox.checked) {
      checkbox.nextElementSibling.innerHTML = thefinercookieJS.remove_from_box;
    } else {
      checkbox.nextElementSibling.innerHTML = thefinercookieJS.add_to_box;
    }
  };

  // Add event listener for all checkboxes
  checkboxes.forEach((checkbox) => {
    buttonText(checkbox);

    checkbox.addEventListener('change', function (e) {
      // Pass the element into the function
      buttonText(this);
    });
  });

  // On Bundle Update (No Choice must jQuery due to 3rd party event listeners)
  $('.bundle_form .cart.bundle_data').on(
    'woocommerce-bundled-item-totals-changed',
    function (e, bundle) {
      let bundled = bundle.get_bundle();
      let price = 0;
      let data = [];

      // Haz bundled items
      if (bundled.bundled_items) {
        // Assign to a variable
        const items = bundled.bundled_items;

        // Loop through the bundle items
        Object.keys(items).forEach(function (key) {
          const item = items[key]; // Assign the item
          const elm = item.$self.get(0); // Set the element

          let isTempSensitive = null;

          let customData = elm.querySelector('.bundled_item_cart_content')
            .dataset.custom_data;

          if (customData) {
            customData = JSON.parse(customData);
          } else {
            customData = {};
          }

          if (customData.hasOwnProperty('temperature_sensitive')) {
            isTempSensitive = customData.temperature_sensitive;
          }

          const checkbox = elm.querySelector('.bundled_product_checkbox'); // Get the checkbox

          const hasQuanity = item.$bundled_item_qty.length; // Get the quantity

          // console.log(checkbox);
          // console.log(item.$bundled_item_qty);

          // console.log(customData);

          try {
            if (hasQuanity) {
              const qtyElmId = item.$bundled_item_qty.get(0).id; // Get the quantity

              let variation = null; // Empty variation
              let variation_price = null; // Empty variation

              // Access the variation text value
              if (item.$attribute_select) {
                variation =
                  item.$attribute_select[0].options[
                    item.$attribute_select[0].selectedIndex
                  ].text;

                variation_price = item.get_variation_data()[0].price;
              } else {
                let bundleId = item.bundled_item_id;

                if (bundleId) {
                  variation_price = bundled.price_data.prices[bundleId];
                }
              }

              if (checkbox) {
                buttonText(checkbox);
              }

              // console.log(parseInt(item.get_product_id()));

              // Push data into array if added to bundle
              if (checkbox && checkbox.checked) {
                checkbox.closest('label').classList.add('active');

                data.push({
                  name: item.bundled_item_product_title,
                  productId: parseInt(item.get_product_id()),
                  quantity: item.get_quantity(),
                  variation: variation,
                  variation_price: variation_price,
                  checkboxName: checkbox.getAttribute('name'),
                  id: qtyElmId,
                  isTempSensitive: isTempSensitive
                });
              } else {
                if (checkbox) {
                  checkbox.closest('label').classList.remove('active');
                }
              }
            } else {
              // console.log(customData);

              throw new Error(
                'No checkbox found for product name: ' +
                  item.bundled_item_product_title
              );
            }
          } catch (error) {
            console.error(error);

            Bugsnag.notify(error);
          }
        });
      }

      // Call Calculate Totals function
      const calculate_totals = bundled.calculate_totals();

      // Price found in bundle
      if (calculate_totals.totals.price) {
        price = calculate_totals.totals.price;
      }

      // Create custom event to send data to vuejs
      const event = new CustomEvent('bundled-products', {
        detail: { data, price }
      });

      // Send custom event
      document
        .querySelector('.bundle_form .cart.bundle_data')
        .dispatchEvent(event);
    }
  );

  const bundleForm = document.querySelector('.cart.bundle_form');

  if (bundleForm) {
    bundleForm.addEventListener('submit', function (e) {
      // console.log('Bundle Form Submitting!');

      // Eww jQuery.
      // Block the page while we wait for a reponse from the backend.
      $('body').block({
        message: null,
        overlayCSS: {
          background: '#fff',
          opacity: 0.8
        }
      });
    });
  }

  // document.body.addEventListener('click', function (e) {
  //   // Bundled checkbox clicked
  //   if (e.target.classList.contains('bundled_product_checkbox')) {
  //     console.log('Bundled checkbox clicked');
  //   }

  //   // Check if add to box button clicked
  //   if (e.target.classList.contains('add_to_box')) {
  //     const checkbox = e.target.previousElementSibling;

  //     console.log(checkbox.checked);

  //     if (checkbox.checked) {
  //       checkbox.checked = false;
  //     } else {
  //       checkbox.checked = true;
  //     }
  //   }

  //   // check if add to cart button clicked
  //   if (e.target.classList.contains('add_to_cart')) {
  //     console.log('Add to cart button clicked');
  //   }

  //   // Pass the element into the function
  //   // alert(
  //   //   'You have cookies in your box but you have not added the box to the cart. Are you sure you want to navigate away from this page?'
  //   // );
  // });

  // window.onbeforeunload = function (e) {
  //   if (document.querySelector('.bundle_form .cart.bundle_data')) {
  //   }

  //   e.preventDefault();

  //   console.log(checkboxes);
  //   console.log(params);

  //   return 'You have cookies in your box but you have not added the box to the cart. Are you sure you want to navigate away from this page?';
  // };
};

export default createBox;
